import { render } from "./PDFCliente.vue?vue&type=template&id=d591520a&scoped=true"
import script from "./PDFCliente.vue?vue&type=script&lang=js"
export * from "./PDFCliente.vue?vue&type=script&lang=js"

import "./PDFCliente.vue?vue&type=style&index=0&id=d591520a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d591520a"]])

export default __exports__